import React from 'react'
import { inject } from 'mobx-react'
import { useState } from 'react'

import { withStyles } from '@material-ui/core/styles'

import { CircularProgress } from '@material-ui/core'
import Scroll from '../../../../components/InfiniteScroll/Scroll'
import Table from '../../../../components/Table/Table'
import { TypeModalEnum } from '../../../../stores/SADT.store'
import { columns } from './utils/columns'

const styles = () => ({
  notFoundContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '80%',
    margin: 10,
  },
})

const CustomizedTable = props => {
  const { classes, TGOStore, loadModelos, last, modelosLoading } = props
  const [ordenarNome, setOrdenarNome] = useState(true)
  const [ordenarStatus, setOrdenarStatus] = useState(true)

  const handleEditar = async id => {
    TGOStore.idModeloSelecionado = id
    TGOStore.changeFieldsStore({
      sugestoes: [],
      sugestoesPagAtual: 0,
      typeModal: TypeModalEnum.EDIT_MODAL,
    })

    await TGOStore.findAllGuiaServicoTussViewQuantidadeUso({
      pageableDTO: {
        pageSize: 6,
        pageNumber: TGOStore.sugestoesPagAtual,
        sortDir: 'DESC',
        sortField: 'quantidadeUso',
      },
    })

    const selecionado = await TGOStore.findByIdGuiaServicoModelo(TGOStore.idModeloSelecionado)
    TGOStore.nomeModelo = selecionado.nome
    TGOStore.statusNovoModelo = selecionado.ativo
    TGOStore.objView.observacao = selecionado.observacao
    TGOStore.objView.guiaServicoTgoTussViews = selecionado.guiaServicoModeloTgoTussViews
    TGOStore.cid10Subcategoria = selecionado.cid10Subcategoria
    TGOStore.objView.indicacaoClinica = selecionado.cid10Subcategoria && {
      value: selecionado.cid10Subcategoria.id,
      label: selecionado.cid10Subcategoria.descricaoAbreviada,
    }

    TGOStore.openModal = true
  }

  const handleDuplicar = async id => {
    TGOStore.idModeloSelecionado = id
    TGOStore.typeModal = TypeModalEnum.EDIT_MODAL
    const selecionado = await TGOStore.findByIdGuiaServicoModelo(TGOStore.idModeloSelecionado)

    await TGOStore.createGuiaServicoModelo(selecionado)
    TGOStore.modelosConfig = []
    TGOStore.pageNumberModelo = 0
    TGOStore.idModeloSelecionado = ''
    await loadModelos()
  }

  const handleAtivar = async id => {
    TGOStore.idModeloSelecionado = id
    await TGOStore.ativarRegistro(TGOStore.idModeloSelecionado)
    TGOStore.modelosConfig = []
    TGOStore.pageNumberModelo = 0
    loadModelos()
  }

  const handleInativar = async id => {
    TGOStore.idModeloSelecionado = id
    await TGOStore.desativarRegistro(TGOStore.idModeloSelecionado)
    TGOStore.modelosConfig = []
    TGOStore.pageNumberModelo = 0
    loadModelos()
  }

  const handleClickOrdenar = value => {
    if (value === 'nome') {
      setOrdenarNome(!ordenarNome)
      TGOStore.sortDirModelo = ordenarNome ? 'DESC' : 'ASC'
      TGOStore.sortFieldModelo = value
      TGOStore.modelosConfig = []
      TGOStore.pageNumberModelo = 0
      loadModelos()
    } else {
      setOrdenarStatus(!ordenarStatus)
      TGOStore.sortDirModelo = ordenarStatus ? 'DESC' : 'ASC'
      TGOStore.sortFieldModelo = value
      TGOStore.modelosConfig = []
      TGOStore.pageNumberModelo = 0
      loadModelos()
    }
  }

  const loadMoreModelos = () => {
    if (modelosLoading) {
      return
    }

    TGOStore.pageNumberModelo =
      TGOStore.modelosConfig.length > 0 ? TGOStore.pageNumberModelo + 1 : 0
    loadModelos()
  }

  return (
    <Scroll loadMore={loadMoreModelos} className={classes.scrollContainer} hasMore={!last} pageStart={0} initialLoad={false}>
      <Table
        dados={TGOStore.modelosConfig}
        columns={columns({
          functions: {
            handleEditar: id => handleEditar(id),
            handleDuplicar: id => handleDuplicar(id),
            handleAtivar: id => handleAtivar(id),
            handleDesativar: id => handleInativar(id),
          },
        })}
        clickable={false}
        ordenarTabela={{
          sortField: TGOStore.sortFieldModelo,
          sortDir: TGOStore.sortDirModelo,
        }}
        comOrdenacao
        handleClickOrdenar={handleClickOrdenar}
      />
      {modelosLoading && (
        <div className={classes.notFoundContainer}>
          <CircularProgress />
        </div>
      )}
    </Scroll>
  )
}

const CustomizedTableWithStyles = withStyles(styles)(CustomizedTable)
export default inject('TGOStore')(CustomizedTableWithStyles)
